import $ from 'jquery';
import madfaviconPath from '../../images/favicon-md.png';
import a1faviconPath from '../../images/favicon-a1.png';

$(function () {
    let faviconPath = madfaviconPath;
    const $a1OfficeMap = $("#a1officeMap");
    if($a1OfficeMap.length > 0){
        faviconPath = a1faviconPath;
        const a1OfficeMap = new google.maps.Map($a1OfficeMap[0], {
            zoom: 16,
            center: new google.maps.LatLng(47.50275, 19.057430),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            styles: [{featureType: "poi", stylers: [{visibility: "off"}]}]
        });

        const a1marker = new google.maps.Marker({
            position: {
                lat: 47.502758, lng: 19.057430
            },
            icon: `${faviconPath}`,
            map: a1OfficeMap
        })
    }

    const $map = $('#officeMap');

    if ($map.length > 0) {
        const map = new google.maps.Map($map[0], {
            zoom: 16,
            center: new google.maps.LatLng(47.4949437, 19.0531779),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            styles: [{featureType: "poi", stylers: [{visibility: "off"}]}]
        });

        const marker = new google.maps.Marker({
            position: {
                lat: 47.4949437, lng: 19.0531779
            },
            icon: `${faviconPath}`,
            map: map
        });
    }

});

